import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import MainButton from '../MainButton';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeTimesheet, timesheetsStatuses } from '../../../../utils/constants';
import classes from './TimeandExpenseActions.module.scss';
// eslint-disable-next-line import/no-cycle
import { EditContext } from '../../../pages/timesheet/Timesheet';
import { PageContext } from '../../../../context/context';
import { generalEnums, submissionEnum } from '../../../../utils/enums';
// eslint-disable-next-line import/no-cycle
import { EditExpenseContext } from '../../../pages/expense/Expense';

export default function TimeandExpenseActions(props) {
  const {
    save,
    submit,
    reject,
    approve,
    submissionType,
    saving,
    rejecting,
    isApprover,
    status,
    customTypes = []
  } = props;
  const size = useWindowSize();
  const { t } = useTranslation();
  const pageCtx = useContext(PageContext);
  const ctx = pageCtx.pageType === generalEnums.TIMESHEET ? useContext(EditContext) : useContext(EditExpenseContext);

  const generateButtonLabel = (type) => {
    let resultLabel = '';

    switch (type) {
      case 'save':
        resultLabel += t('common.general.save');
        break;
      case 'submit':
        resultLabel += t('common.general.submit');
        break;
      case 'delete':
        resultLabel += t('common.general.delete');
        break;
      default:
        resultLabel = '';
        break;
    }

    if (size.width < responsiveSizeTimesheet) return resultLabel;

    if (pageCtx.pageType !== generalEnums.EXPENSE) {
      resultLabel +=
        submissionType === submissionEnum.WEEKLY ? ` ${t('common.general.week')}` : ` ${t('common.general.month')}`;
    }

    return resultLabel;
  };

  if (isApprover && status === timesheetsStatuses(t, isApprover).rejected.apiStatus) return false;

  if (isApprover && status === timesheetsStatuses(t, isApprover).submitted.apiStatus) {
    return (
      <div className={classes.container}>
        <MainButton
          size="small"
          variant="secondary"
          outlined
          rounded
          action={reject}
          forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
        >
          {rejecting ? <CircularProgress size="20px" /> : t('common.general.reject')}
        </MainButton>
        <MainButton
          size="small"
          variant="primary"
          rounded
          action={approve}
          forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
        >
          {t('common.general.approve')}
        </MainButton>
      </div>
    );
  }

  if (!isApprover && customTypes.length) {
    return (
      <div className={classes.container}>
        {customTypes.map((type) => (
          <MainButton
            key={type.label}
            size="small"
            variant={ctx.hasChanges ? type.variant : 'disabled'}
            outlined={type.variant === 'secondary'}
            rounded
            action={type.handler}
            disabled={type.disableHandler}
            forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
          >
            {!type.saving ? (
              generateButtonLabel(type.label)
            ) : (
              <CircularProgress size="20px" sx={{ color: '#003b58' }} />
            )}
          </MainButton>
        ))}
      </div>
    );
  }

  return ![timesheetsStatuses(t).approved.label, timesheetsStatuses(t).processed.label].includes(status) ? (
    <div className={classes.container}>
      {ctx.isEdit ? (
        <>
          <MainButton
            disabled={saving || !ctx.hasChanges}
            size="small"
            variant={ctx.hasChanges ? 'primary' : 'disabled'}
            outlined
            rounded
            action={save}
            forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
          >
            {!saving ? generateButtonLabel('save') : <CircularProgress size="20px" sx={{ color: '#003b58' }} />}
          </MainButton>
          {status === timesheetsStatuses(t).draft.label ? (
            <MainButton
              size="small"
              variant="primary"
              outlined={false}
              rounded
              action={submit}
              forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
            >
              {generateButtonLabel('submit')}
            </MainButton>
          ) : (
            ((ctx.hasChanges && status === timesheetsStatuses(t).submitted.label) ||
              status === timesheetsStatuses(t).rejected.label) && (
              <MainButton
                size="small"
                variant="primary"
                outlined={false}
                rounded
                action={submit}
                forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
              >
                {t('common.general.resubmit')}
              </MainButton>
            )
          )}
        </>
      ) : (
        <MainButton
          size="small"
          variant="primary"
          outlined
          rounded
          action={() => ctx.setIsEdit(true)}
          forceWidth={size.width > responsiveSizeTimesheet ? 'fit-content' : '100%'}
        >
          {t('common.general.edit')}
        </MainButton>
      )}
    </div>
  ) : null;
}
